import { render, staticRenderFns } from "./PatientTagPicker.vue?vue&type=template&id=2b7dd000"
import script from "./PatientTagPicker.vue?vue&type=script&lang=js"
export * from "./PatientTagPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports